import { useCallback, useRef } from "react";
import {BlockerFunction, useBeforeUnload, useBlocker} from "react-router-dom";

export const useNavigationBlocker = (hasDataChanged: () => boolean) => {
    const useBlockerRef = useRef(true);

    const shouldBlock = useCallback<BlockerFunction>(({ currentLocation, nextLocation }) =>
            useBlockerRef.current && hasDataChanged() && currentLocation.pathname !== nextLocation.pathname,
        [hasDataChanged]);

    const blocker = useBlocker(shouldBlock);
    
    const setBlockerActive = (active: boolean) => {
        useBlockerRef.current = active;
    }

    useBeforeUnload(useCallback((e: BeforeUnloadEvent) => {
        if (!useBlockerRef.current || !hasDataChanged()) return;
        e.preventDefault();
        e.returnValue = true; // Included for legacy support, e.g. Chrome/Edge < 119
    }, [hasDataChanged]));

    return {blocker, setBlockerActive};
}